import React, { PropTypes } from 'react';

export default function App(props) {
  return (
    <div>
      {props.children}
    </div>
  );
}

// describes the property types available to this component
App.propTypes = {
  children: PropTypes.element,
};



// WEBPACK FOOTER //
// ./src/components/app.jsx